import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import {
  CopyButtonDashed,
  CopyButtonDashedNew,
  FertilityOfferContainer,
  FertilityOfferHead,
  OfferContainer,
  OfferInfo,
  OfferProducts,
  OfferTag,
  ProductImg,
} from './styled';
import Cookies from 'js-cookie';
import { SnackBar } from '../../Product/PdpHeader/styled';
import { fireEvent } from '../../../Utils/fireEvent';

const OfferSection = (props) => {
  const { offerData, isFertilityProduct, productId } = props;
  const [showToast, setshowToast] = useState(false);
  const [toastValue, setToastValue] = useState('Apply on checkout!');
  const [clickEffect, setClickEffect] = useState('');
  const eventHandler = (data) => {
    if (isFertilityProduct) {
      fireEvent({
        category: 'clicked_offer_on_pdp',
        support_variable: data.offer_heading ? data.offer_heading : data,
        sku_id: productId,
        cta: 'copyCode',
      });
    } else
      fireEvent({
        category: 'clicked_offer_on_pdp',
        support_variable: data.offer_heading ? data.offer_heading : data,
      });
    setToastValue('Copied successfully');
    setClickEffect('lowOpacity');
    setshowToast(true);
    setTimeout(() => {
      setshowToast(false);
    }, 2000);
    setTimeout(() => {
      setClickEffect('');
    }, 300);
  };
  const onCopyCoupon = (data) => {
    if (!Cookies.get('coupon_code')) {
      Cookies.set('coupon_code', data);
    }
    window?.navigator?.clipboard?.writeText(`${data}`);
    eventHandler({ offer_heading: data });
  };
  useEffect(() => {
    if (!isFertilityProduct)
      fireEvent({
        category: 'served_section_in_myloshop',
        screen_name: 'stroller_landing_page',
        section_id: '',
        shape: 'SECTION',
        section_name: 'Get free baby wellness kit',
        card_ids: '',
      });
  }, []);

  const productFacts = [
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725617797119-Results-in-5-mintues.svg',
      text: 'Results in 5 minutes',
    },
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725617844253-99-Accuracy.svg',
      text: '99% Accuracy',
    },
  ];

  return (
    <FertilityOfferContainer>
      {isFertilityProduct ? (
        <FertilityOfferHead>Offers:</FertilityOfferHead>
      ) : null}
      <OfferContainer
        onClick={() => onCopyCoupon(offerData?.offerCode)}
        className={clickEffect}
        isFertilityProduct={isFertilityProduct}
      >
        {isFertilityProduct ? (
          <>
            <div className="offerDetails">
              <OfferInfo isFertilityProduct={isFertilityProduct}>
                <p>
                  {offerData?.offerName} <span className="free">FREE</span>
                </p>
                <div>
                  {productFacts.map((item, index) => (
                    <div key={index} className="facts">
                      <img src={item.icon} alt={item.text} />
                      <div className="factText">{item.text}</div>
                    </div>
                  ))}
                </div>
              </OfferInfo>
              <ProductImg>
                <Image
                  src="https://images.myloapp.in/NestJsUploads/1725619016578-freebie.webp"
                  quality={90}
                  alt=""
                  fill
                  sizes="33vw"
                />
              </ProductImg>
            </div>
            <CopyButtonDashedNew>
              <div className="codeContainer">
                <div>Use Code</div>
                <span>{offerData?.offerCode}</span>
              </div>
              <button>Copy Code</button>
            </CopyButtonDashedNew>
          </>
        ) : (
          <div className="offerDetails">
            <ProductImg>
              <Image
                src={offerData?.offerImg}
                quality={90}
                alt=""
                fill
                sizes="33vw"
              />
            </ProductImg>
            <OfferInfo>
              <p>{offerData?.offerName}</p>
              <span>{offerData?.offerValid}</span>
              <CopyButtonDashed>
                <span>{offerData?.offerCode}</span>
                <button>Copy Code</button>
              </CopyButtonDashed>
            </OfferInfo>
          </div>
        )}
        <OfferProducts>
          {isFertilityProduct ? null : (
            <>
              <span>Kit Contains:</span>
              <p>{offerData?.offerProducts}</p>
            </>
          )}
        </OfferProducts>

        {!isFertilityProduct && (
          <OfferTag>
            {offerData?.offerTag}
            <span></span>
          </OfferTag>
        )}
        <SnackBar className={showToast ? 'show' : ''}>{toastValue}</SnackBar>
      </OfferContainer>
    </FertilityOfferContainer>
  );
};

export default OfferSection;
